import { render } from "./add-schedule-header.vue?vue&type=template&id=2cf6777a"
import script from "./add-schedule-header.vue?vue&type=script&lang=js"
export * from "./add-schedule-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__